import _objectWithoutProperties from "/app/web/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "/app/web/node_modules/@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["isMultiple", "isReadonly", "allowClear", "placeholder", "emptyMessage"];

var _APPRAISAL_TYPE_MAP;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { CarOutlined, PhoneOutlined } from '@ant-design/icons';
import { Select, Space } from 'antd';
import { AppraisalType } from 'core/client';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { sanitizeAll } from '../../utils/sanitize';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var APPRAISAL_TYPE_MAP = (_APPRAISAL_TYPE_MAP = {}, _defineProperty(_APPRAISAL_TYPE_MAP, AppraisalType.InPerson, /*#__PURE__*/_jsx(CarOutlined, {})), _defineProperty(_APPRAISAL_TYPE_MAP, AppraisalType.Remote, /*#__PURE__*/_jsx(PhoneOutlined, {})), _APPRAISAL_TYPE_MAP);

/** Renders a select to select task appraisal type */
export var TaskAppraisalTypeSelect = function TaskAppraisalTypeSelect(_ref) {
  var isMultiple = _ref.isMultiple,
      isReadonly = _ref.isReadonly,
      allowClear = _ref.allowClear,
      placeholder = _ref.placeholder,
      emptyMessage = _ref.emptyMessage,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var options = Object.values(AppraisalType);
  return /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({}, props), {}, {
    mode: isMultiple ? 'multiple' : undefined,
    allowClear: allowClear,
    bordered: !isReadonly,
    disabled: isReadonly,
    showSearch: true,
    filterOption: function filterOption(input, option) {
      return sanitizeAll(option.title).includes(sanitizeAll(input));
    },
    placeholder: isReadonly ? emptyMessage : placeholder,
    children: options.map(function (type) {
      return /*#__PURE__*/_jsx(Select.Option, {
        value: type,
        title: t("form.task.appraisalType.type.".concat(type)),
        children: /*#__PURE__*/_jsxs(OptionContent, {
          size: "small",
          children: [/*#__PURE__*/_jsx("span", {
            className: "icon",
            children: APPRAISAL_TYPE_MAP[type]
          }), /*#__PURE__*/_jsx("span", {
            className: "label",
            children: t("form.task.appraisalType.type.".concat(type))
          })]
        })
      }, type);
    })
  }));
}; // Styles

var OptionContent = styled(Space).withConfig({
  displayName: "TaskAppraisalTypeSelect__OptionContent",
  componentId: "sc-eciece-0"
})([""]);